var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "toolbar",
        { attrs: { title: "Untethered Listings" } },
        [
          _c("v-icon", { on: { click: _vm.refreshListings } }, [
            _vm._v("refresh")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { column: "" } },
        [
          _c(
            "v-layout",
            { staticClass: "mt-2", attrs: { column: "" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "", "align-end": "" } },
                        [
                          _c("v-flex", { attrs: { xs6: "" } }),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "append-icon": "search",
                                  label: "Search Listings",
                                  "single-line": "",
                                  "hide-details": ""
                                },
                                model: {
                                  value: _vm.search,
                                  callback: function($$v) {
                                    _vm.search = $$v
                                  },
                                  expression: "search"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-data-table", {
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.headers,
                      "custom-filter": _vm.filterListings,
                      search: _vm.search,
                      items: _vm.listings,
                      "rows-per-page-items": [10, 20, 30]
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "items",
                        fn: function(props) {
                          return [
                            _c(
                              "td",
                              { staticClass: "text-xs-left" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "mx-0",
                                    attrs: { color: "accent" },
                                    on: {
                                      click: function($event) {
                                        return _vm.viewListingDetail(
                                          props.item.listingHumanId
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { size: "18", color: "white" } },
                                      [_vm._v("visibility")]
                                    ),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(props.item.listingHumanId) +
                                        "\n              "
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-left" },
                              [
                                _c("v-flex", [
                                  _c("b", [_vm._v("From:")]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm._f("originName")(props.item)
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("v-flex", [
                                  _c("b", [_vm._v("To:")]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm._f("destinationName")(props.item)
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("normalizeDistance")(
                                      _vm._.get(props.item, "loadedMiles", 0)
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("formatDate")(props.item.pickupTime)
                                  ) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(props.item.loadCount) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-xs-left" }, [
                              _c("span", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(props.item.bids.placed) +
                                    " bids\n                "
                                ),
                                props.item.bids.placed > 0
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                  from " +
                                          _vm._s(props.item.bids.minimumBid) +
                                          "\n                "
                                      )
                                    ])
                                  : _vm._e()
                              ]),
                              _c("br"),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(props.item.bids.availableLoadCount) +
                                    "\n              load"
                                ),
                                props.item.bids.availableLoadCount !== 1
                                  ? _c("span", [_vm._v("s")])
                                  : _vm._e(),
                                _vm._v(" still available\n            ")
                              ])
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d09d037c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d09d037c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Untethered.vue
// module id = null
// module chunks = 